import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-right mb-4" }
const _hoisted_2 = {
  filter: "createdOn",
  filterType: "date",
  sort: "createdOn"
}
const _hoisted_3 = {
  filter: "nome",
  sort: "nome"
}
const _hoisted_4 = {
  filter: "subTitle",
  sort: "subTitle"
}
const _hoisted_5 = {
  filter: "productType",
  sort: "productType"
}
const _hoisted_6 = {
  filter: "displayOrder",
  sort: "displayOrder"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "99" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: "/shopConfig/product/0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_localized_text, {
            localizedKey: "Nuovo prodotto",
            text: "Nuovo prodotto"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.items
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data creazione",
                text: "Data creazione"
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nome",
                text: "Nome"
              })
            ]),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Sottotitolo",
                text: "Sottotitolo"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Tipo prodotto",
                text: "Tipo prodotto"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Ordinamento",
                text: "Ordinamento"
              })
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn)), 1),
              _createElementVNode("td", null, _toDisplayString(item.nome), 1),
              _createElementVNode("td", null, _toDisplayString(item.subTitle), 1),
              _createElementVNode("td", null, _toDisplayString(item.productType), 1),
              _createElementVNode("td", null, _toDisplayString(item.displayOrder), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  class: "btn btn-primary ml-2",
                  to: '/shopConfig/product/' + item.identifier
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Dettaglio",
                      text: "Dettaglio"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-link ml-2",
                  onClick: ($event: any) => (_ctx.duplicaItem(item))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Duplica",
                    text: "Duplica"
                  })
                ], 8, _hoisted_10),
                (_ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger ml-2",
                      onClick: ($event: any) => (_ctx.removeItem(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Elimina",
                        text: "Elimina"
                      })
                    ], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}